// @generated by protoc-gen-connect-es v1.6.1
// @generated from file ai/h2o/mlops/deployer/v1/kubernetes_resource_spec_service.proto (package ai.h2o.deploy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetDefaultRuntimeKubernetesResourceSpecRequest, GetDefaultRuntimeKubernetesResourceSpecResponse } from "@buf/h2oai_mlops-deployment.bufbuild_es/ai/h2o/mlops/deployer/v1/kubernetes_resource_spec_service_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service ai.h2o.deploy.KubernetesResourceSpecService
 */
export const KubernetesResourceSpecService = {
  typeName: "ai.h2o.deploy.KubernetesResourceSpecService",
  methods: {
    /**
     * Gets default runtime K8s resource spec.
     *
     * @generated from rpc ai.h2o.deploy.KubernetesResourceSpecService.GetDefaultRuntimeKubernetesResourceSpec
     */
    getDefaultRuntimeKubernetesResourceSpec: {
      name: "GetDefaultRuntimeKubernetesResourceSpec",
      I: GetDefaultRuntimeKubernetesResourceSpecRequest,
      O: GetDefaultRuntimeKubernetesResourceSpecResponse,
      kind: MethodKind.Unary,
    },
  }
};

